function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWcaLogoicon = function SvgWcaLogoicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 256 256"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M536.253-428.589c-.02-19.972-.022-27.821 0-58.33 105.406-.177 182.312 64.219 218.155 126.425-45.15 26.27-50.108 29.128-50.108 29.128-33.117-56.639-96.179-96.545-168.047-97.223M366.22-133.728l.015-192.06 166.022 95.886-.179 191.156c-55.56-31.182-165.858-94.982-165.858-94.982",
    style: {
      fill: "#ddda45",
      strokeWidth: 0.873144
    },
    transform: "matrix(.50092 0 0 .49999 -139.547 243.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.37-133.964c36.272-65.476 30.509-138.95-.03-193.855.397-1.032 33.464-19.338 50.105-29.137 51.218 93.815 36.52 189.217.142 252.073-20.354-11.426-31.067-17.784-50.216-29.08",
    style: {
      fill: "#e7762a",
      strokeWidth: 0.873144
    },
    transform: "matrix(.50092 0 0 .49999 -139.547 243.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.348-356.462 50.351 28.277c-35.185 70.658-31.885 124.212-.287 194.132l-50.135 28.724c-50.424-90.849-36.123-187.146.07-251.133M536.242-229.908c56.137-32.739 165.617-95.118 165.617-95.118-.675 128.214.054 8.158-.218 191.352C647.251-101.3 596.41-72.67 536.14-38.746c-.316-40.224.102-46.62.102-191.162",
    style: {
      fill: "#e02826",
      strokeWidth: 0.873144
    },
    transform: "matrix(.50092 0 0 .49999 -139.547 243.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.773-360.677c38.71-70.102 124.625-126.44 218.12-126.24v58.329c-79.93 2.845-135.217 43.397-168.143 96.873-19.035-11.012-28.323-16.475-49.977-28.962",
    style: {
      fill: "#3d9c46",
      strokeWidth: 0.873144
    },
    transform: "matrix(.50092 0 0 .49999 -139.547 243.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.467-130.49c36.872 61.387 101.902 96.577 168.559 97.4l.052 58.183c-87.517.537-172.831-47.822-218.646-126.668Z",
    style: {
      fill: "#eeeeec",
      strokeWidth: 0.873144
    },
    transform: "matrix(.50092 0 0 .49999 -139.547 243.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.784-329.039 165.28-95.19 165.545 95.607-165.36 95.093zM536.252 25.093c-.15-22.246-.263-38.397-.113-58.184 78.824.022 144.072-53.088 168.106-97.178 21.654 12.497 29.748 17.203 50.235 29.023-70.66 121.281-200.1 126.34-218.228 126.34",
    style: {
      fill: "#304a96",
      strokeWidth: 0.873144
    },
    transform: "matrix(.50092 0 0 .49999 -139.547 243.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.472-109.239c0-11.246-.164-13.101-1.272-14.394-.7-.816-15.496-9.238-32.88-18.716-34.428-18.768-37.648-20.694-42.213-25.236-5.55-5.522-5.575-5.664-5.858-33.804-.243-24.176-.207-24.978 1.188-25.999 2.914-2.133 2.422-2.363 44.543 20.905 36.86 20.362 34.93 19.392 35.806 18.007.365-.576.668-6.816.674-13.865.011-11.182-.15-13.002-1.26-14.265-1.482-1.686-69.352-39.351-74.692-41.45-12.363-4.86-20.158-2.799-24.23 6.409-2.512 5.682-2.979 11.788-2.97 38.87.01 35.39 1.46 44.783 8.86 57.405 3.602 6.145 13.578 16.315 20.275 20.672 2.646 1.721 19.977 11.396 38.512 21.5 24.618 13.421 33.945 18.17 34.608 17.621.665-.548.909-4.216.909-13.66M505.1-276.945c1.626-.83 3.444-2.263 4.042-3.185s6.236-11.568 12.531-23.658 11.673-21.98 11.95-21.98c.28 0 5.726 10.165 12.105 22.59 7.967 15.516 12.334 23.242 13.95 24.674 4.823 4.276 13.933 4.702 19.407.907 2.719-1.884 4.51-5.152 23.165-42.245 11.12-22.112 20.04-40.666 19.823-41.23-.317-.83-2.69-1.027-12.225-1.018-6.507.01-12.2.252-12.652.545s-6.769 12.43-14.037 26.97c-7.352 14.706-13.49 26.153-13.83 25.796-.339-.352-5.597-10.286-11.686-22.076s-11.883-22.534-12.876-23.877c-4.878-6.594-16.588-6.788-21.987-.363-.982 1.17-7.018 12.167-13.412 24.438-6.395 12.272-11.802 22.316-12.017 22.32-.214.01-6.088-11.519-13.052-25.606s-13.134-26.187-13.71-26.886c-.918-1.113-2.463-1.27-12.38-1.26-6.233.008-11.792.301-12.353.657-1.12.709 4.584 13.165 26.312 57.463 11.69 23.832 13.178 26.098 18.407 28.045 3.752 1.397 10.748.905 14.525-1.021M631.02-246.392c-.474.02-.976.098-1.522.218-2.822.62-7.136 4.938-9.079 9.086-.835 1.782-8.73 23.677-17.542 48.655a93678 93678 0 0 1-24.455 69.24c-4.638 13.103-8.23 24.152-7.981 24.554.44.714 6.654-2.4 15.952-7.995l4.359-2.623 6.538-18.882 6.542-18.879 23.235-12.9c12.78-7.093 23.47-12.896 23.752-12.896s2.865 4.263 5.737 9.476c2.873 5.212 5.793 10.179 6.488 11.037l1.262 1.562 8.267-4.693c4.547-2.582 8.37-5.23 8.497-5.887.126-.657-7.094-15.04-16.045-31.96-8.95-16.92-19.159-36.26-22.688-42.979-6.077-11.569-8.005-14.28-11.317-14.134m-3.312 35.65c1.023.328 12.917 22.286 12.466 23.015-.405.656-22.033 12.56-24.52 13.497-.982.37.129-3.593 5.086-18.122 3.488-10.226 6.624-18.5 6.968-18.39",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.873144
    },
    transform: "matrix(.50092 0 0 .49999 -139.547 243.454)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#fff",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.388 2073.02a88.5 88.5 0 0 1-88.5 88.5 88.5 88.5 0 0 1-88.5-88.5 88.5 88.5 0 0 1 88.5-88.5 88.5 88.5 0 0 1 88.5 88.5z",
    style: {
      fill: "none",
      strokeWidth: 20
    },
    transform: "translate(224.68 8.733)scale(.10878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.488 2065.02c5.5 0 9.5-1.1 11.9-3.2 2.4-2 3.7-5.4 3.7-10.2 0-4.7-1.3-8-3.7-10.1-2.4-2-6.4-3-11.9-3h-11.2v26.5h11.2m-11.2 18.3v39h-26.6v-103.1h40.6c13.6 0 23.5 2.3 29.8 6.9 6.4 4.5 9.5 11.7 9.5 21.6 0 6.8-1.6 12.4-4.9 16.8-3.3 4.3-8.2 7.6-14.9 9.6 3.7.9 6.9 2.8 9.8 5.7s5.8 7.3 8.7 13.3l14.5 29.2h-28.3l-12.6-25.6c-2.5-5.1-5.1-8.7-7.7-10.5-2.6-1.9-6.1-2.9-10.4-2.9h-7.5",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 1.00334,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(224.68 8.733)scale(.10878)"
  })));
};
export default SvgWcaLogoicon;